import { render, staticRenderFns } from "./ShopNav.vue?vue&type=template&id=a947694c&"
import script from "./ShopNav.vue?vue&type=script&lang=js&"
export * from "./ShopNav.vue?vue&type=script&lang=js&"
import style0 from "./ShopNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports